import React from 'react'
import { SvgIcon } from '@mui/material'

export const EmojiIcon = () => (
  <SvgIcon
    viewBox="0 0 20 21"
    sx={{ width: '20px', height: '21px', color: 'gray' }}
  >
    <path d="M13.5 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM6.5 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM10 16.5c2.28 0 4.22-1.66 5-4H5c.78 2.34 2.72 4 5 4Z" />
    <path d="M9.99.5C4.47.5 0 4.98 0 10.5s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10S15.52.5 9.99.5Zm.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Z" />
  </SvgIcon>
)
